import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import axios from "axios";
import { Formik, Form, Field } from "formik";
import { Link, useHistory } from "react-router-dom";
import Loader from "../../components/Loading/loading";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faPlus,
  faAngleLeft,
  faAngleRight,
} from "@fortawesome/free-solid-svg-icons";
import "../../static/css/talentStyle.css";
import user from "../../static/images/user_default.png";
import useBaseURL from "../../Hooks/useBaseURL";

function Talento() {
  const [search, setsearch] = useState(true);
  const [departmentList, setdepartmentList] = useState([]);
  const [contractList, setcontractList] = useState([]);
  const [listIdiomas, setlistIdiomas] = useState([]);
  const [listHabilidades, setlistHabilidades] = useState([]);
  const [idiomasSelected, setidiomasSelected] = useState([]);
  const [habilidadesSelected, sethabilidadesSelected] = useState([]);
  const [searchResults, setsearchResults] = useState([]);
  const [loading, setloading] = useState(true);
  const baseUrl = useBaseURL();

  const history = useHistory();

  const [CurrentPage, setCurrentPage] = useState(0);
  const [perPage, setperPage] = useState(5);
  useEffect(() => {
    setCurrentPage(0);
  }, [searchResults, perPage]);

  useEffect(() => {
    getDepartment();
    getContrats();
    ListLenguajes();
    ListSkills();
  }, []);

  const getDepartment = () => {
    axios.get("department-list").then((result) => {
      setdepartmentList(result.data);
    });
  };

  const getContrats = () => {
    axios.get("contract/list-contracts").then((result) => {
      setcontractList(result.data);
    });
  };

  const ListLenguajes = () => {
    axios.get("applicant-languages/list-language/").then((result) => {
      setlistIdiomas(result.data);
    });
  };

  const ListSkills = () => {
    axios.get("skills/list-skills").then((result) => {
      setlistHabilidades(result.data);
      setloading(false);
    });
  };

  const SelectIdioma = (e) => {
    let { value } = e.target;
    let filter = idiomasSelected.find((x) => x.id == value);
    if (filter === undefined) {
      let idioma = listIdiomas.find((x) => x.id == value);
      setidiomasSelected([...idiomasSelected, idioma]);
    } else toast.error("Idioma ya seleccionado");
  };

  const SelectHabilidad = (e) => {
    let { value } = e.target;
    let filter = habilidadesSelected.find((x) => x.skillId == value);

    if (filter === undefined) {
      let habilidad = listHabilidades.find((x) => x.skillId == value);
      sethabilidadesSelected([...habilidadesSelected, habilidad]);
    } else toast.error("Habilidad ya seleccionado");
  };

  const GetHabilidadesArr = () => {
    let idiomaArr = [];

    habilidadesSelected.map((item) => {
      idiomaArr.push(item.skillId);
    });
    return idiomaArr;
  };

  const GetIdiomasArr = () => {
    let habilidadArr = [];

    idiomasSelected.map((item) => {
      habilidadArr.push(item.id);
    });
    return habilidadArr;
  };

  const getData = (values) => {
    let se = {
      contratoId: 0,
      departamentoId: values.departamentoId,
      habilidades: GetHabilidadesArr(),
      idiomas: GetIdiomasArr(),
      profesion: values.profesion,
    };

    axios
      .post("access/buscar-talento", se)
      .then((result) => {
        setsearchResults(result.data);
        if (!result.data.length > 0) {
          toast.success("No se encontraron resultados", { duration: 5000 });
          setsearch(true);
        } else {
          setsearch(false);
        }
        setloading(false);
      })
      .catch(function (error) {
        if (!error.status) {
          toast.error(
            "Problemas para conectarse al servidor, favor verifique su conexion e intentelo nuevamente",
            { duration: 5000 }
          );
        } else if (error.response.status === 400) {
          toast.error(error.response.data.message);
        } else if (error.request) {
        }
      });
  };

  const goToProfile = (id) => {
    let path =
      localStorage.getItem("rol") === "institute"
        ? "/CentroFormacion/Candidato"
        : "/company/Candidato/";

    history.push({
      pathname: path,
      state: { userid: id },
    });
  };

  return (
    <div className="main-container">
      {loading ? <Loader type="full"></Loader> : ""}
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <ul className="tabs remove-list-style reset-list">
              <li
                className="tabs__item active"
                style={{ width: "100%" }}
                onClick={() => setsearch(true)}
              >
                <a className="tabs__link" href="#">
                  Encuentra Talento
                </a>
              </li>
            </ul>

            {search ? (
              <div id="jobs">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-md-12 mt-4">
                      <div className="">
                        <div className="row">
                          <div className="col-md-12">
                            <div className="content" style={{ width: "100%" }}>
                              <Formik
                                initialValues={{
                                  contratoId: 0,
                                  departamentoId: 0,
                                  profesion: "",
                                }}
                                onSubmit={(values, { setSubmitting }) => {
                                  setSubmitting(true);
                                  setloading(true);
                                  getData(values);
                                  setSubmitting(false);
                                }}
                              >
                                {({ isSubmitting }) => (
                                  <Form
                                    className="tab-content"
                                    id="pills-tabContent"
                                  >
                                    <div
                                      className="tab-pane fade show active"
                                      id="pills-home"
                                      role="tabpanel"
                                      aria-labelledby="pills-tab1"
                                    >
                                      <div className="row">
                                        <div className="col">
                                          <h6>Información</h6>
                                        </div>
                                      </div>
                                      <div className="row mt-4">
                                        <div className="col-xs-12 col-md-4">
                                          <div className="mb-3">
                                            <label
                                              htmlFor="exampleFormControlInput1"
                                              className="form-label"
                                            >
                                              Cargo/Puesto:
                                            </label>
                                            <Field
                                              type="text"
                                              className="form-control"
                                              placeholder="Supervisor de Ventas"
                                              name="profesion"
                                            ></Field>
                                          </div>
                                        </div>

                                        <div className="col-xs-12 col-md-4">
                                          <div className="mb-3">
                                            <label
                                              htmlFor="exampleFormControlInput1"
                                              className="form-label"
                                            >
                                              Ubicación
                                            </label>
                                            <Field
                                              as="select"
                                              className="form-select"
                                              aria-label="Default select example"
                                              name="departamentoId"
                                            >
                                              <option hidden></option>
                                              {departmentList.map((item) => {
                                                return (
                                                  <option
                                                    key={item.departmentId}
                                                    value={item.departmentId}
                                                  >
                                                    {item.name}
                                                  </option>
                                                );
                                              })}
                                            </Field>
                                          </div>
                                        </div>
                                        {/* <div className="col-xs-12 col-md-4">
                                          <div className="mb-3">
                                            <label
                                              htmlFor="exampleFormControlInput1"
                                              className="form-label"
                                            >
                                              Edad
                                            </label>
                                            <select
                                              className="form-select"
                                              aria-label="Default select example"
                                            >
                                              <option selected>20 años</option>
                                              <option value="1">30 años</option>
                                              <option value="2">45 años</option>
                                            </select>
                                          </div>
                                        </div> */}
                                        <div className="col-xs-12 col-md-4">
                                          <div className="mb-3">
                                            <label
                                              htmlFor="exampleFormControlInput1"
                                              className="form-label"
                                            >
                                              Tipo de Contrato
                                            </label>
                                            <Field
                                              as="select"
                                              className="form-select"
                                              aria-label="Default select example"
                                              name="contractId"
                                            >
                                              <option hidden></option>
                                              {contractList.map((item) => {
                                                return (
                                                  <option
                                                    key={item.contractId}
                                                    value={item.contractId}
                                                  >
                                                    {item.name}
                                                  </option>
                                                );
                                              })}
                                            </Field>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="row row-t0">
                                      <div className="col-md-6">
                                        <p className="m-st">
                                          Habilidades y Aptitudes
                                        </p>
                                        <div className="mb-3 btn-box">
                                          <div className="gap-2 flex-wrap flex flex-row">
                                            {habilidadesSelected.map(
                                              (item, index) => {
                                                return (
                                                  <div
                                                    className="rounded-2xl bg-neutral-500 text-white px-2 py-1"
                                                    role="alert"
                                                  >
                                                    {item.name}
                                                    <div
                                                      className="bg-red-400 rounded-full ml-2 inline-block h-4 w-4 cursor-pointer"
                                                      onClick={() => {
                                                        sethabilidadesSelected(
                                                          habilidadesSelected.filter(
                                                            (x) =>
                                                              x.skillId !==
                                                              item.skillId
                                                          )
                                                        );
                                                      }}
                                                    ></div>
                                                  </div>
                                                );
                                              }
                                            )}
                                            <div
                                              data-bs-toggle="modal"
                                              data-bs-target="#agregar-habilidad-vacante-modal"
                                              className="bg-gradient-to-r rounded-full min-w-20 px-2 py-1 text-white flex flex-row items-center cursor-pointer"
                                              style={{ background: "#9100ff" }}
                                            >
                                              Añadir
                                              <FontAwesomeIcon
                                                icon={faPlus}
                                                className="text-white ml-4"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      {/* <div className="col-md-6">
                                        <p className="m-st">Insignias</p>
                                        <div className="mb-3 btn-box">
                                          <div className="row">
                                            <div className="col">...</div>
                                          </div>
                                        </div>
                                      </div> */}
                                      <div className="col-md-6">
                                        <p className="m-st">Idiomas</p>
                                        <div className="mb-3 btn-box">
                                          <div className="gap-2 flex-wrap flex flex-row">
                                            {idiomasSelected.map(
                                              (item, index) => {
                                                return (
                                                  <div
                                                    className="rounded-2xl bg-neutral-500 text-white px-2 py-1"
                                                    role="alert"
                                                  >
                                                    {item?.description}
                                                    <div
                                                      className="bg-red-400 rounded-full ml-2 inline-block h-4 w-4 cursor-pointer"
                                                      onClick={() => {
                                                        setidiomasSelected(
                                                          idiomasSelected.filter(
                                                            (x) =>
                                                              x.id !== item.id
                                                          )
                                                        );
                                                      }}
                                                    ></div>
                                                  </div>
                                                );
                                              }
                                            )}
                                            <div
                                              data-bs-toggle="modal"
                                              data-bs-target="#agregar-idioma-vacante-modal"
                                              className="bg-gradient-to-r rounded-full min-w-20 px-2 py-1 text-white flex flex-row items-center cursor-pointer"
                                              style={{ background: "#9100ff" }}
                                            >
                                              Añadir
                                              <FontAwesomeIcon
                                                icon={faPlus}
                                                className="text-white ml-4"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row mt-5 mb-4 text-end">
                                      <div
                                        id="buttons"
                                        className="col-12 col-md-4"
                                      >
                                        <button
                                          type="submit"
                                          className="btn btn-info"
                                          disabled={isSubmitting}
                                        >
                                          Buscar
                                        </button>
                                      </div>
                                    </div>
                                  </Form>
                                )}
                              </Formik>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="kr-modal modal fade"
                  id="agregar-idioma-vacante-modal"
                  tabIndex="-1"
                  aria-labelledby="exampleModalLabel"
                  aria-hidden="true"
                >
                  <div
                    className="modal-dialog modal-dialog-centered"
                    role="document"
                  >
                    <div className="modal-content">
                      <div className="modal-header">
                        <div className="modal-title"></div>

                        <div
                          className="close"
                          data-bs-dismiss="modal"
                          aria-label="close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </div>
                      </div>

                      <div className="modal-body">
                        <div className="mb-4 row">
                          <label htmlFor="languageId" className="col-sm-2 pe-0">
                            Idiomas
                          </label>
                          <div className="col-sm-10">
                            <select
                              id="languageId"
                              name="languageId"
                              className="form-select form-select-sm"
                              onChange={(e) => SelectIdioma(e)}
                            >
                              <option hidden>Seleccione un Idioma</option>
                              {listIdiomas.map((item, index) => {
                                return (
                                  <option key={index} value={item.id}>
                                    {item.description}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="kr-modal modal fade"
                  id="agregar-habilidad-vacante-modal"
                  tabIndex="-1"
                  aria-labelledby="exampleModalLabel"
                  aria-hidden="true"
                >
                  <div
                    className="modal-dialog modal-dialog-centered"
                    role="document"
                  >
                    <div className="modal-content">
                      <div className="modal-header">
                        <div className="modal-title"></div>

                        <div
                          className="close"
                          data-bs-dismiss="modal"
                          aria-label="close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </div>
                      </div>

                      <div className="modal-body">
                        <div className="mb-4 row">
                          <label
                            htmlFor="habilidades"
                            className="col-sm-2 pe-0"
                          >
                            Habilidades
                          </label>
                          <div className="col-sm-10">
                            <select
                              className="form-select form-select-sm"
                              onChange={(e) => SelectHabilidad(e)}
                            >
                              <option hidden>Seleccione una Habilidad</option>
                              {listHabilidades.map((item, index) => {
                                return (
                                  <option key={index} value={item.skillId}>
                                    {item.name}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div
                id="talentTab1"
                className="general-content-wrapper border-box"
              >
                <div id="nav-tabContent" className="row mt-3"></div>
                <div className="bordered-box" style={{ display: "block" }}>
                  <div className="tab-content" id="pills-tabContent">
                    <div
                      className="tab-pane fade show active"
                      id="pills-tab1"
                      role="tabpanel"
                      aria-labelledby="pills-home-tab"
                    >
                      <div className="row">
                        <div className="col-md-6 mt-4">
                          <h6 className="center-text">
                            Resumen de tu busqueda
                          </h6>
                        </div>
                        <div className="w-full h-12 flex items-center justify-end">
                          <div
                            className="px-4 rounded-3xl bg-gradient-to-r from-[#9100ff] to-[#4b00ff] text-white h-5/6 flex items-center justify-center cursor-pointer"
                            onClick={() => setsearch(true)}
                          >
                            <FontAwesomeIcon
                              icon={faArrowLeft}
                              className="text-white pr-2"
                            />
                            Regresar
                          </div>
                        </div>
                        <hr></hr>
                        <div className="my-2 flex flex-col w-full ">
                          <div className="flex flex-row w-full ">
                            <div className="bg-purple-600 translate-x-4 px-2 flex items-center rounded-l-xl">
                              <p className="text-white mr-4">
                                Resultados por página
                              </p>
                            </div>
                            <div
                              className={`px-3 py-2  z-10 text-lg ${
                                perPage == 5 ? "bg-[#8c00ff]" : "bg-[#601e95]"
                              } rounded-l-xl text-white cursor-pointer`}
                              onClick={() => setperPage(5)}
                            >
                              5
                            </div>
                            <div
                              className={`px-3 py-2 text-lg ${
                                perPage == 8 ? "bg-[#8c00ff]" : "bg-[#601e95]"
                              } text-white cursor-pointer`}
                              onClick={() => setperPage(8)}
                            >
                              8
                            </div>
                            <div
                              className={`px-3 py-2 text-lg ${
                                perPage == 10 ? "bg-[#8c00ff]" : "bg-[#601e95]"
                              } rounded-r-xl text-white cursor-pointer`}
                              onClick={() => setperPage(10)}
                            >
                              10
                            </div>
                          </div>
                          <div className="flex flex-row w-full mt-4 items-center justify-center gap-1">
                            {searchResults.length > perPage ? (
                              <>
                                <div
                                  className="bg-purple-600 rounded-md px-2 py-1 text-2xl text-white cursor-pointer"
                                  onClick={() => {
                                    if (CurrentPage > 0) {
                                      setCurrentPage(CurrentPage - 1);
                                    }
                                  }}
                                >
                                  <FontAwesomeIcon icon={faAngleLeft} />
                                </div>
                                {CurrentPage > 0 ? (
                                  <div className="bg-purple-600 rounded-md px-2 py-1 text-2xl text-white">
                                    1
                                  </div>
                                ) : (
                                  <></>
                                )}
                                <div className="bg-purple-900 rounded-md px-2 py-1 text-2xl text-white">
                                  {CurrentPage + 1}
                                </div>
                                {CurrentPage <
                                Math.ceil(searchResults.length / perPage) -
                                  1 ? (
                                  <div className="bg-purple-600 rounded-md px-2 py-1 text-2xl text-white">
                                    {Math.ceil(searchResults.length / perPage)}
                                  </div>
                                ) : (
                                  <></>
                                )}
                                <div
                                  className="bg-purple-600 rounded-md px-2 py-1 text-2xl text-white cursor-pointer"
                                  onClick={() => {
                                    if (
                                      CurrentPage <
                                      Math.ceil(
                                        searchResults.length / perPage
                                      ) -
                                        1
                                    ) {
                                      setCurrentPage(CurrentPage + 1);
                                    }
                                  }}
                                >
                                  <FontAwesomeIcon icon={faAngleRight} />
                                </div>
                              </>
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                      </div>
                      {searchResults
                        .slice(
                          CurrentPage * perPage,
                          CurrentPage * perPage + perPage
                        )
                        .map((item) => {
                          return (
                            <div
                              key={item.aplicanteId}
                              className="row mb-6 align-items-center"
                            >
                              <div className="col-2" style={{ width: "150px" }}>
                                <div className="box-imgUser">
                                  <img
                                    src={
                                      item.foto != undefined ? item.foto : user
                                    }
                                    alt=""
                                  ></img>
                                </div>
                              </div>
                              <div className="col-8">
                                <p className="nameUser mt-2">{item.nombre}</p>
                                <p className="skills">
                                  {item.habilidades.map((skill) => {
                                    return skill.habilidad + " ";
                                  })}
                                </p>
                                <p className="description mb-0 pe-4">
                                  {item.acerca}
                                </p>
                              </div>
                              <div className="col-2 actions" id="insignias">
                                <Link
                                  to={`/${baseUrl}/chat?create=${item.userId}`}
                                  type="button"
                                  className="btn btn-light mb-2"
                                >
                                  Enviar mensaje
                                </Link>
                                <button
                                  type="button"
                                  className="btn btn-info"
                                  onClick={() => goToProfile(item.aplicanteId)}
                                >
                                  Ver
                                </button>
                              </div>
                            </div>
                          );
                        })}
                    </div>
                    <br></br>
                    <div className="row mb-4 mt-5 text-center">
                      <div id="buttons" className="col-md-12">
                        <button
                          type="button"
                          className="btn btn-info"
                          onClick={() => {
                            setsearch(true);
                          }}
                        >
                          Nueva Búsqueda
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Talento;
